// FLAG_ALTERNATE_PROJECT_TITLES
// User facing project names - this version uses country names instead of projects, for demo purposes. All projects are included to prevent bugs
// NOTE: Duplicates must have a space after them, or there will be bugs
const projectListCountriesHack = {
	aatf: "AATF",
	china: "China",
	russia: "Russia",

	// The rest are standard projects, included to prevent possible bugs
	afghanistandemo: "Afghanistan",
	afghanistanDFAT: "Afghanistan - DFAT",
	africom: "Baghdad",
	arlis: "Fido",
	asksage: "Ask Sage",
	au2024_trial: "Thunder Trial",
	islamabad: "Islamabad",
	kabul: "Kabul",
	koala: "Koala",

	// Remove ???
	balticsDemo: "GEC-Demo",
	bcbs: "BCBS",
	bsca: "BSCA",
	cbp: "Central America",
	dccc: "DCCC",
	dcos: "Afghanistan",
	iraq: "Iraq",
	iran: "Iran",
	midterms: "Midterms",
	pnnl: "PNNL-China",
	politics2020: "United States",
	sayara: "Venezuela ",
	sevenTwenty: "BMA",
	sevenTwenty_uscc: "Texas 23 District",
	texas23: "USCC Texas 23rd",
	usip: "USIP",
	venezuela: "Venezuela",
	walmart: "Walmart",
};

export default projectListCountriesHack;
